import * as React from 'react';
import {LegalFrame} from '@volkswagen-onehub/components-core';
import {FrameProps} from '@volkswagen-onehub/whitelabel-e-mobility-commons';
import styled from 'styled-components';

export function Frame({
  text,
  linkText,
  link,
  noMaxWidth,
  children,
}: FrameProps): JSX.Element {
  return (
    <LegalFrameWrapper noMaxWidth={noMaxWidth}>
      <LegalFrame text={text} linkText={linkText} link={link}>
        {children}
      </LegalFrame>
    </LegalFrameWrapper>
  );
}

const LegalFrameWrapper = styled.div<{noMaxWidth?: boolean}>`
  > div > div {
    ${({noMaxWidth}) => noMaxWidth && 'max-width: none;'}
  }
`;
